export default __webpack_public_path__ + "media/zurb/img/playground/ux-metric-card-breakdown-d398086e108e15559c4032f1bccdbd40.png";